'use strict';

module.exports = function findGetResult(v, x) {
    return x;
};
